<template>
  <div class="wrapper-document">
    <b-loading :isFullPage="false" :active="isLoading" />
    <div class="link">
      <div class="columns custom-align-center">
        <routerLink
          class="column is-inherited"
          role="link"
          rel="search tag"
          :to="
            !isEditable
              ? {
                  path: `/app/documento/${document.id}`,
                  query: { processId: process.id }
                }
              : ``
          "
        >
          <b-tooltip
            :label="document.attachment_name"
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
            :active="showDocNameTooltip"
            class="tooltip-break-word"
            size="is-large"
            multilined
          >
            <div
              class="doc-name is-size-6 document-selected has-text-weight-semibold"
            >
              {{ document.attachment_name }}
            </div>
          </b-tooltip>
          <div class="columns is-size-7-5 has-text-color-7 my-0">
            <div class="ml-10 py-0">
              <span class="has-text-weight-semibold">{{ General.TYPE }}: </span>
              {{ documentType }}
            </div>
            <template v-if="!document.editable">
              <div class="ml-10 p-0">
                <template v-if="document.is_doe_document_model">
                  <span class="has-text-weight-semibold"
                    >{{ General.DOCUMENT_OFFICIAL_NUMBER }}:
                  </span>
                  {{ document.code }}
                </template>
                <template v-else>
                  <span class="has-text-weight-semibold"
                    >{{ General.DOCUMENT_NUMBER }}:
                  </span>
                  {{ document.document_number }}
                </template>
              </div>
              <div v-if="document.page" class="ml-10 py-0">
                <span class="has-text-weight-semibold"
                  >{{ General.PROCESS_PAGE }}:
                </span>
                {{ document.page }}
              </div>
            </template>
          </div>
          <div class="is-size-7-5 has-text-color-7">
            <span class="has-text-weight-semibold">
              {{ General.ADDED_ON }}
            </span>
            <label class="has-text-weight-normal">{{
              new Date(document.date) | dateFormat("DD/MM/YYYY")
            }}</label
            ><span>{{ ` às` }} </span>
            <label class="has-text-weight-normal">{{
              new Date(document.date) | dateFormat("HH:mm:ss")
            }}</label>
            <span class="has-text-weight-semibold">
              {{ General.PER.toLowerCase() }}
            </span>
            <label
              v-if="
                document.capacity_id && getCapacityById(document.capacity_id)
              "
              class="has-text-weight-normal"
            >
              {{
                `${getCapacityById(document.capacity_id).entity.abbreviation}/${
                  getCapacityById(document.capacity_id).abbreviation
                } - ${document.user_name}`
              }}
            </label>
          </div>
        </routerLink>
        <div v-if="document.private || document.notVisible" class="column is-1">
          <b-icon v-if="document.private" icon="lock" />
          <b-icon v-else-if="document.notVisible" icon="eye-slash" />
        </div>

        <div class="column is-3 custom-justify-flex-end mobile-flex-start">
          <div class="is-flex-wrap-wrap">
            <b-tag
              v-if="document.sequence === 0"
              type="is-success"
              size="is-small is-rounded"
            >
              {{ General.INICIAL_PETITION }}
            </b-tag>

            <b-tooltip
              v-if="document.is_validated"
              :type="isContrast ? 'is-black' : 'is-white'"
              multilined
              position="is-top"
              class="list-authenticate"
            >
              <div @mouseover.once="getAuthenticatedData()">
                <b-tag type="is-primary" size="is-small is-rounded">
                  {{ General.AUTHENTICATED }}
                </b-tag>
              </div>
              <template v-slot:content>
                <section v-if="!hasAuthenticatedList" style="height: 30px">
                  <b-loading
                    :isFullPage="false"
                    :active="!hasAuthenticatedList"
                  />
                </section>
                <section v-else>
                  <div class="has-text-color-7 has-text-weight-semibold">
                    {{ General.DOCUMENT_AUTHENTICATED_BY }}
                  </div>
                  <div
                    v-for="(item, index) in autheticatedList"
                    :key="index"
                    class="authenticated has-text-color-7"
                  >
                    <br />
                    <div>
                      <div class="spacing-mr-5"><i class="ball"></i></div>
                    </div>
                    <span class="flex-1 has-text-left">
                      {{
                        `${item.user_name} (${capacityFormatted(
                          item.capacity_id
                        )})`
                      }}
                    </span>
                  </div>
                </section>
              </template>
            </b-tooltip>

            <b-tag
              v-if="document.no_effect"
              class="spacing-mr-20 is-brown-dark"
              type="is-blue-dark"
              size="is-small is-rounded"
            >
              {{ General.DOCUMENT_WITHOUT_EFFECT }}
            </b-tag>

            <b-tag
              v-if="
                document &&
                  document.current_doe_status !== 'NOT_TO_PUBLISH' &&
                  !isEditable
              "
              class="spacing-mr-20"
              :type="findColorDoe(document.current_doe_status)"
              size="is-small is-rounded"
            >
              {{
                App.DOE_STATUS[document.current_doe_status] ||
                  App.DOE_STATUS.UNKNOWN
              }}
            </b-tag>
          </div>

          <div>
            <b-tooltip
              v-if="mandatorySignatures.length"
              :type="isContrast ? 'is-black' : 'is-white'"
              multilined
              :always="showTooltip[DOC_SIGN.MANDATORY]"
              class="list-sign"
              :size="isMobile ? tooltipMobileSize : 'is-large'"
              :position="isMobile ? 'is-right' : 'is-top'"
            >
              <div
                @mouseover="setShowTooltip(DOC_SIGN.MANDATORY, true)"
                @mousemove="setShowTooltip(DOC_SIGN.MANDATORY, false)"
              >
                <b-icon
                  :icon="
                    allMandatoryFinished
                      ? 'pencil-circle'
                      : 'checkbox-blank-circle'
                  "
                  type="is-blue-oil"
                  size="is-small"
                />
              </div>
              <template v-slot:content>
                <section
                  class="container-new"
                  @mouseout="setShowTooltip(DOC_SIGN.MANDATORY, false)"
                  @mousemove="setShowTooltip(DOC_SIGN.MANDATORY, true)"
                >
                  <span class="has-text-weight-semibold">{{
                    General.MANDATORY_SIGNATURE
                  }}</span>
                  <div
                    v-for="(signature, index) in mandatorySignatures.slice(
                      0,
                      4
                    )"
                    :key="signature.user_id"
                    class="is-justify-content-space-between"
                    :class="signature.is_signed.toLowerCase() || 'mandatory'"
                  >
                    <div>
                      <br />
                      <div class="spacing-mr-5"><i class="ball"></i></div>
                      <span class="flex-1 has-text-left">
                        {{
                          `${signature.user_name} ${General
                            .ASSIGN_STATE_MANDATORY[signature.is_signed] ||
                            ""}${
                            mandatorySignatures.length > 4 && index == 3
                              ? " " + General.TEXTS.AND_OTHERS
                              : ""
                          }${
                            index == mandatorySignatures.slice(0, 4).length - 1
                              ? "."
                              : ""
                          }`
                        }}
                      </span>
                    </div>
                    <div v-if="hasPermissionMandatorySignature">
                      <b-tooltip
                        v-if="signature.is_signed !== 'assigned'"
                        :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                        position="is-top"
                        multilined
                        size="is-small"
                        :label="General.DELETE"
                      >
                        <span
                          class="is-clickable"
                          @click="removeMandatory(signature)"
                        >
                          <b-icon
                            icon="delete"
                            :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                          />
                        </span>
                      </b-tooltip>
                      <b-tooltip
                        v-if="!signature.is_signed && !isEditable"
                        :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                        position="is-top"
                        multilined
                        size="is-small"
                        :label="General.REQUEST_SUBSCRIPTION"
                      >
                        <span
                          class="is-clickable"
                          @click="requestSignature(signature)"
                        >
                          <b-icon
                            icon="pen-plus"
                            :type="isContrast ? 'is-white' : 'is-blue-oil'"
                          />
                        </span>
                      </b-tooltip>
                    </div>
                  </div>
                  <div
                    v-if="hasPermissionMandatorySignature"
                    class="action-signature is-justify-content-flex-end"
                  >
                    <span
                      class="has-text-weight-semibold has-text-color-7 mt-5 is-clickable"
                      @click="showMandatorySignatureModal()"
                      >{{ General.CHANGE_MANDATORY_SIGNATURE }}</span
                    >
                  </div>
                </section>
              </template>
            </b-tooltip>

            <b-tooltip
              v-if="processFileSignCount(DOC_SIGN.SIGNED)"
              :type="isContrast ? 'is-black' : 'is-white'"
              multilined
              :always="showTooltip[DOC_SIGN.SIGNED]"
              class="list-sign"
              :size="isMobile ? tooltipMobileSize : 'is-large'"
              :position="isMobile ? 'is-right' : 'is-top'"
            >
              <div
                data-cy="SIGNED_BUTTON"
                @mouseover="setShowTooltip(DOC_SIGN.SIGNED, true)"
                @mousemove="setShowTooltip(DOC_SIGN.SIGNED, false)"
              >
                <b-icon
                  icon="checkbox-marked-circle"
                  type="is-primary"
                  size="is-small"
                />
              </div>
              <template v-slot:content>
                <section
                  class="container-new"
                  @mouseout="setShowTooltip(DOC_SIGN.SIGNED, false)"
                  @mousemove="setShowTooltip(DOC_SIGN.SIGNED, true)"
                >
                  <span class="has-text-weight-semibold">{{
                    General.SIGNATURES_MADE
                  }}</span>
                  <div
                    v-for="(item, index) in processFileSign(DOC_SIGN.SIGNED)"
                    :key="item.user_id"
                    :class="item.status.toLowerCase()"
                  >
                    <br />
                    <div>
                      <div class="spacing-mr-5"><i class="ball"></i></div>
                    </div>
                    <span class="flex-1 has-text-left">
                      {{
                        `${item.user_name} (${capacityFormatted(
                          item.capacity
                        )})${
                          processFileSignCount(DOC_SIGN.SIGNED) > 4 &&
                          index == 3
                            ? " " + General.TEXTS.AND_OTHERS
                            : ""
                        }${
                          index == processFileSign(DOC_SIGN.SIGNED).length - 1
                            ? "."
                            : ""
                        }`
                      }}
                    </span>
                  </div>
                </section>
              </template>
            </b-tooltip>

            <b-tooltip
              v-if="processFileSignCount(DOC_SIGN.PENDING)"
              :type="isContrast ? 'is-black' : 'is-white'"
              multilined
              :always="showTooltip[DOC_SIGN.PENDING]"
              class="list-sign"
              :size="isMobile ? tooltipMobileSize : 'is-large'"
              :position="isMobile ? 'is-right' : 'is-top'"
            >
              <div
                @mouseover="setShowTooltip(DOC_SIGN.PENDING, true)"
                @mousemove="setShowTooltip(DOC_SIGN.PENDING, false)"
              >
                <b-icon icon="alert-circle" type="is-pending" size="is-small" />
              </div>
              <template v-slot:content>
                <section
                  class="container-new"
                  @mouseout="setShowTooltip(DOC_SIGN.PENDING, false)"
                  @mousemove="setShowTooltip(DOC_SIGN.PENDING, true)"
                >
                  <span class="has-text-weight-semibold">{{
                    General.SIGNATURES_PENDING
                  }}</span>
                  <div
                    v-for="(signature, index) in processFileSign(
                      DOC_SIGN.PENDING
                    )"
                    :key="signature.user_id"
                    :class="signature.status.toLowerCase()"
                  >
                    <br />
                    <div>
                      <div class="spacing-mr-5"><i class="ball"></i></div>
                    </div>
                    <span class="flex-1 has-text-left">
                      {{
                        `${signature.user_name} (${capacityFormatted(
                          signature.capacity
                        )})${
                          processFileSignCount(DOC_SIGN.PENDING) > 4 &&
                          index == 3
                            ? " " + General.TEXTS.AND_OTHERS
                            : ""
                        }${
                          index == processFileSign(DOC_SIGN.PENDING).length - 1
                            ? "."
                            : ""
                        }`
                      }}
                    </span>
                    <span
                      class="is-clickable"
                      @click="cancelSignatureModal(signature)"
                    >
                      <b-icon
                        icon="delete"
                        :type="isContrast ? 'is-white' : 'is-blue-oil'"
                      />
                    </span>
                  </div>
                  <div class="action-signature">
                    <span
                      class="has-text-weight-semibold has-text-color-7 mt-5 is-clickable"
                      @click="cancelSignatureModal(false, DOC_SIGN.PENDING)"
                      >{{ General.REMOVE_ALL }}</span
                    >
                  </div>
                </section>
              </template>
            </b-tooltip>

            <b-tooltip
              v-if="processFileSignCount(DOC_SIGN.REFUSED)"
              :type="isContrast ? 'is-black' : 'is-white'"
              multilined
              :always="showTooltip[DOC_SIGN.REFUSED]"
              class="list-sign"
              :size="isMobile ? tooltipMobileSize : 'is-large'"
              :position="isMobile ? 'is-right' : 'is-top'"
            >
              <div
                @mouseover="setShowTooltip(DOC_SIGN.REFUSED, true)"
                @mousemove="setShowTooltip(DOC_SIGN.REFUSED, false)"
              >
                <b-icon icon="close-circle" type="is-refused" size="is-small" />
              </div>
              <template v-slot:content>
                <section
                  class="container-new"
                  @mouseout="setShowTooltip(DOC_SIGN.REFUSED, false)"
                  @mousemove="setShowTooltip(DOC_SIGN.REFUSED, true)"
                >
                  <span class="has-text-weight-semibold">{{
                    General.SIGNATURES_REFUSED
                  }}</span>
                  <div
                    v-for="(item, index) in processFileSign(DOC_SIGN.REFUSED)"
                    :key="item.user_id"
                    :class="item.status.toLowerCase()"
                  >
                    <br />
                    <div>
                      <div class="spacing-mr-5"><i class="ball"></i></div>
                    </div>
                    <span
                      class="flex-1 has-text-left"
                      :class="{ 'has-text-white': isContrast }"
                    >
                      {{
                        `${item.user_name} (${capacityFormatted(
                          item.capacity
                        )})${
                          processFileSignCount(DOC_SIGN.REFUSED) > 4 &&
                          index == 3
                            ? " " + General.TEXTS.AND_OTHERS
                            : ""
                        }${
                          index == processFileSign(DOC_SIGN.REFUSED).length - 1
                            ? "."
                            : ""
                        }`
                      }}
                    </span>
                  </div>
                  <div class="action-signature">
                    <span
                      class="has-text-weight-semibold has-text-color-7 mt-5 is-clickable"
                      @click="cancelSignatureModal(false, DOC_SIGN.REFUSED)"
                      >{{ General.DELETE }}</span
                    >
                    <span
                      class="has-text-weight-semibold has-text-color-7 mt-5 is-clickable"
                      @click="resendSignatureModal(false, DOC_SIGN.REFUSED)"
                      >{{ General.REQUEST_AGAIN }}</span
                    >
                  </div>
                </section>
              </template>
            </b-tooltip>
          </div>
        </div>

        <div class="columns is-mobile column is-4">
          <div v-if="showPublishSwitch" class="column is-6">
            <b-switch
              v-model="publishSwitch"
              leftLabel
              :disabled="!isPublish"
              @input="setToPublish"
              >{{ General.DOE_PUBLISH }}</b-switch
            >
          </div>

          <div class="column custom-justify-flex-end">
            <ActionsGrouper :actions="actionList()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import ModalDocSignature from "@/views/App/ModalDocSignature";
import ModalSignDocument from "@/views/App/ModalSignDocument";
import ModalSelectUser from "@/views/App/ModalSelectUser";
import ModalWarning from "@/views/App/ModalWarning.vue";
import ModalDocMandatorySignature from "@/views/App/ModalDocMandatorySignature";
import ModalDeclinePublication from "@/views/App/ModalDeclinePublication.vue";

import { App, General } from "@/utils/constants";
import { downloadWithURL } from "@/utils/fileUtility";
import {
  USER_PERMISSIONS as userPermissions,
  DOC_SIGNATURES_STATUS as DOC_SIGN,
  SIZES as sizes,
  MAX_SIGN_SIZE
} from "@/utils/enumerate";
import { showErrorMessage } from "@/utils/messageUtility";

export default {
  name: "DocumentDetails",
  props: {
    process: {
      type: Object,
      default: () => {}
    },
    document: {
      type: Object,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    isRemoveFileAllowed: {
      require: false,
      type: Boolean,
      default: false
    },
    isUserResponsable: {
      type: Boolean,
      default: () => false
    },
    isEditable: {
      require: false,
      type: Boolean,
      default: () => false
    },
    isAppendedProcess: {
      type: Boolean,
      default: () => false
    },
    isConfidential: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      App,
      General,
      DOC_SIGN,
      showDetails: false,
      icon: "",
      documentsSelectedSignRequested: [],
      orderState: [DOC_SIGN.SIGNED, DOC_SIGN.PENDING, DOC_SIGN.REFUSED],
      publishSwitch: this.document.to_publish,
      isLoading: false,
      showTooltip: {
        REFUSED: false,
        PENDING: false,
        SIGNED: false,
        MANDATORY: false
      },
      autheticatedList: []
    };
  },

  computed: {
    ...mapGetters({
      getCapacityById: "getCapacityById",
      user: "getCurrentUser",
      hasPermission: "hasPermission",
      isContrast: "isContrast",
      isMobile: "isMobile",
      getCapacityFormatted: "getCapacityFormatted",
      getPublishExtension: "getPublishExtensionList",
      getFileTypeById: "getFileTypeById",
      mobileSize: "mobileSize"
    }),

    allMandatoryFinished() {
      return this.mandatorySignatures.every(
        signature => signature.is_signed === "assigned"
      );
    },

    hasPermissionPublishDOE() {
      return this.hasPermission(userPermissions["PUBLISH_DOE"]);
    },

    hasPermissionMandatorySignature() {
      if (this.hasPermissionPublishDOE || this.hasPermissionAuthorizeDOE)
        return !["PUBLISHED", "AUTHORIZED"].includes(
          this.document.current_doe_status
        );
      return false;
    },

    canShowModalAuthorizeDOE() {
      return (
        ((this.hasPermissionPublishDOE && !this.process.nup) ||
          this.hasPermissionAuthorizeDOE) &&
        !["PUBLISHED", "AUTHORIZED"].includes(this.document.current_doe_status)
      );
    },

    hasPermissionAuthorizeDOE() {
      return this.hasPermission(userPermissions["AUTHORIZE_DOE"]);
    },

    hasPublish() {
      const state = this.document?.current_doe_status;
      return ["TO_PUBLISH", "REFUSED", "NOT_TO_PUBLISH"].includes(state);
    },

    isPublish() {
      return (
        this.document?.current_doe_status === "TO_PUBLISH" ||
        !this.document?.to_publish
      );
    },

    documentType() {
      const fileType =
        this.getFileTypeById(
          this.document.document_type || this.document.document_type_id
        ).type || "";

      return fileType;
    },

    validateRequestSignature() {
      const documentNotProcessed =
        this.document.sequence === null &&
        this.document.user_id === this.userId;

      return this.isUserResponsable || documentNotProcessed;
    },

    isNoEffect() {
      return this.document.no_effect;
    },

    mandatorySignatures() {
      return this.document.doe_obrigatory_signature;
    },

    showDocNameTooltip() {
      return this.document.attachment_name.length > 60;
    },

    tooltipMobileSize() {
      if (this.mobileSize === sizes.IS_SMALL) return sizes.IS_SMALL;
      else return sizes.IS_MEDIUM;
    },

    showPublishSwitch() {
      return (
        this.isEditable &&
        this.hasDoeFormat &&
        this.hasDOETypeValid &&
        this.hasPermissionPublishDOE &&
        this.isUserResponsable
      );
    },

    doeAttachmentExtension() {
      const extensionList = this.getPublishExtension || [];
      if (!extensionList.length) return false;
      return extensionList.some(({ name }) =>
        this.document.file?.endsWith(name)
      );
    },

    hasDoeFormat() {
      return (
        this.document.gdocs_id ||
        this.document.is_doe_document_model ||
        this.doeAttachmentExtension
      );
    },

    hasDOETypeValid() {
      return this.getFileTypeById(
        this.document.document_type || this.document.document_type_id
      ).to_publish;
    },

    hasCurrentUserValidSignature() {
      return this.document.sign_history.some(
        signature =>
          signature.user_id === this.user.id &&
          signature.only_historical === false
      );
    },

    getDownloadTooltip() {
      return this.isEditable
        ? this.General.DOWNLOAD
        : this.General.DOWNLOAD_PRINTABLE_VERSION;
    },

    hasAuthenticatedList() {
      return this.autheticatedList.length;
    },

    hasPermissionViewConfidential() {
      return this.hasPermission(userPermissions["VIEW_CONFIDENTIAL_PROCESS"]);
    }
  },

  methods: {
    ...mapActions({
      deleteProcessFileRequest: "deleteProcessFileRequest",
      cancelSignatureFile: "cancelSignatureFileRequest",
      processToPublishRequest: "processToPublishRequest",
      deleteObrigatorySignature: "deleteObrigatorySignature",
      postExternalSubscriberRequest: "postExternalSubscriberRequest",
      postSubscriberRequest: "postSubscriberRequest",
      authorizeToPublish: "authorizeToPublishRequest",
      requestFile: "requestDataProcessFile",
      requestProcessFiles: "processFilesFilteredRequest",
      updateProcessFile: "updateProcessFile",
      getFileCanGiveKnowledgeRequest: "getFileCanGiveKnowledgeRequest",
      getFileSizeRequest: "getFileSizeRequest",
      getFileValidatorsRequest: "getFileValidatorsRequest"
    }),
    ...mapMutations(["setCurrentProcessFileList"]),

    async deleteFile() {
      await this.deleteProcessFileRequest({ file: this.document });
    },

    async showModalDocSignature() {
      const canSign = await this.sizeCanSign(true);
      if (!canSign) return;

      this.setCurrentProcessFileList([this.document]);
      this.$buefy.modal.open({
        parent: this,
        component: ModalDocSignature,
        props: {
          processId: this.document.process_id,
          updateFiles: this.updateProcessFiles
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async updateProcessFiles() {
      await this.requestProcessFiles({
        files_id: [this.document.id],
        processId: this.document.process_id
      });
    },

    handleDocumentSelectedSign() {
      const capacity_id =
        this.document.length > 1
          ? this.user.capacity.capacity_id
          : this.capacityToSign(this.document.sign_history);
      this.$store.commit("setListSelectedDocuments", {
        documents: [
          {
            process_file: {
              ...this.document,
              document_type: { description: this.documentType },
              process: {
                nup: this.process.nup || General.TEXTS.NUP_NOT_GENERATED
              }
            }
          }
        ],
        capacity_id
      });
    },

    isLargeFile(fileSize) {
      return fileSize > MAX_SIGN_SIZE;
    },

    async sizeCanSign(isSignRequest = false) {
      const fileSize = await this.getFileSizeRequest(this.document.id);

      if (this.isLargeFile(fileSize)) {
        const message = isSignRequest
          ? this.General.MESSAGES.ALERT_REQUEST_SIGNATURE_OVERSIZED_FILE
          : this.General.MESSAGES.ALERT_SIGN_OVERSIZED_FILE;
        showErrorMessage(message, false, "is-danger");
        return false;
      }
      return true;
    },

    async showModalSignDocument() {
      const canSign = await this.sizeCanSign();
      if (!canSign) return;

      this.handleDocumentSelectedSign();

      this.$buefy.modal.open({
        parent: this,
        component: ModalSignDocument,
        hasModalCard: true,
        trapFocus: true
      });
    },

    async showModalGiveKnowledge() {
      const canGiveKnowledge = await this.getFileCanGiveKnowledgeRequest({
        processId: this.process.id,
        processFileId: this.document.id
      });
      if (!canGiveKnowledge) {
        showErrorMessage(
          this.General.MESSAGES.ERROR_NO_PERMISSION,
          false,
          "is-danger"
        );
        return;
      }

      this.$buefy.modal.open({
        parent: this,
        component: ModalSelectUser,
        props: { fileIds: [this.document], process: { id: this.process.id } },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async downloadFile() {
      const printer_version = this.isEditable ? undefined : true;
      const result = await this.requestFile({
        fileIds: [{ process_file_id: this.document.id }],
        processId: this.process.id,
        printer_version
      });
      if (result) {
        const [{ url_file, attachment_name }] = result;
        downloadWithURL(
          url_file,
          attachment_name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\W/g, "_"),
          url_file.match(/\w{1,20}$/)[0]
        );
      }
    },

    signatureHistoryType(type) {
      return this.document.sign_history.length
        ? this.document.sign_history.filter(
            signature => signature.status === type && !signature.only_historical
          )
        : [];
    },

    processFileSignCount(type) {
      return this.signatureHistoryType(type).length;
    },

    processFileSign(type) {
      return this.signatureHistoryType(type).slice(0, 4);
    },

    async publishDocument(toPublish) {
      this.isLoading = true;
      const result = await this.processToPublishRequest({
        toPublish,
        processId: this.process.id,
        processFileId: this.document.id,
        keepReference: true,
        nup: this.process.nup
      });
      this.isLoading = false;
      return result;
    },

    async setToPublish(toPublish) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: toPublish
            ? `${General.MESSAGES.DOCUMENT_WILL_BE_PUBLISHED}`
            : `${General.MESSAGES.DOCUMENT_WILL_NOT_BE_PUBLISHED}`,
          confirm: async () => {
            const successPublish = await this.publishDocument(toPublish);
            this.updateProcessFile({
              list: [
                {
                  ...this.file,
                  to_publish: successPublish ? toPublish : !toPublish
                }
              ]
            });
            if (successPublish) {
              toPublish && this.showMandatorySignatureModal();
            } else {
              this.publishSwitch = !toPublish;
            }
          },
          deny: () => (this.publishSwitch = !toPublish),
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true,
        onCancel: () => (this.publishSwitch = !toPublish)
      });
    },

    showModalAuthorizeDOE() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: `${General.TEXTS.AUTHORIZE_PUBLICATION_DOE}?`,
          confirm: async () => {
            await this.authorizeToPublish({
              authorize: true,
              processFileId: this.document.id,
              processId: this.document.process_id
            });
            await this.updateProcessFiles();
          },
          buttons: [
            { label: General.YES, isConfirm: true, action: true },
            { label: General.NO, isConfirm: false, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    findColorDoe(status) {
      return (
        {
          REFUSED: "is-refused",
          PUBLISHED: "is-green-lawn",
          PROGRAMMED: "is-orange",
          AUTHORIZED: "is-yellow",
          TO_PUBLISH: "is-blue-oil",
          PARTIALLY_PUBLISHED: "is-orange"
        }[status] || "is-orange"
      );
    },

    async resendRequest() {
      this.isLoading = true;
      const internalSignatureList = this.documentsSelectedSignRequested
        .filter(sub => sub.user_id)
        .map((sub, index) => {
          return {
            user_id: sub.user_id,
            capacity_id: sub.capacity,
            process_file_id: this.document.id,
            order: index
          };
        });

      const externalSignatureList = this.documentsSelectedSignRequested
        .filter(sub => !sub.user_id)
        .map(sub => {
          return {
            email: sub.external_signature_email,
            name: sub.user_name,
            capacity_id: sub.capacity,
            process_file_id: this.document.id,
            cpf_cnpj: sub.user_cpf.replace(/\D/g, ""),
            id: sub.id
          };
        });
      if (internalSignatureList.length)
        await this.postSubscriberRequest({
          subscribers: [internalSignatureList],
          processId: this.process.id,
          hasOrder: false,
          joinId: this.document.document_join_id
        });
      if (externalSignatureList.length)
        await this.postExternalSubscriberRequest({
          subscriber: externalSignatureList,
          processId: this.process.id
        });
      await this.updateProcessFiles();
      this.isLoading = false;
    },

    async resendSignatureModal(signature = null, type = null) {
      if (signature?.id) this.documentsSelectedSignRequested = [signature];
      else if (type)
        this.documentsSelectedSignRequested = this.signatureHistoryType(type);

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: `${this.General.MSG_RESEND_SIGNATURE}?`,
          confirm: () => this.resendRequest(),
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async cancelRequest() {
      this.isLoading = true;
      const list_signature_cancel = this.documentsSelectedSignRequested.map(
        signature => ({
          signature_file_id: signature.id
        })
      );
      await this.cancelSignatureFile(list_signature_cancel);
      await this.updateProcessFiles();
      this.isLoading = false;
    },

    async cancelSignatureModal(signature = null, type = null) {
      if (signature?.id) this.documentsSelectedSignRequested = [signature];
      else if (type)
        this.documentsSelectedSignRequested = this.signatureHistoryType(type);

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: `${this.General.TEXTS.CONFIRM_CANCEL_REQUEST}?`,
          confirm: () => this.cancelRequest(),
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    setShowTooltip(type, state) {
      this.showTooltip[type] = state;
    },

    async getAuthenticatedData() {
      this.autheticatedList = await this.getFileValidatorsRequest(
        this.document.id
      );
    },

    async removeMandatory(signature) {
      if (this.mandatorySignatures.length === 1) {
        this.snackToast.open({
          message: this.General.MESSAGES.ERROR_DROP_ALL_MANDATORY_SIGNATURE,
          type: "is-danger",
          duration: 8000
        });
        return;
      }
      this.isLoading = true;
      if (signature?.id) await this.deleteObrigatorySignature(signature.id);
      await this.updateProcessFiles();
      this.isLoading = false;
    },

    async requestSignature(signatureRef) {
      this.isLoading = true;
      if (signatureRef?.id) {
        const subscribers = [
          [
            {
              user_id: signatureRef.user_id,
              capacity_id: signatureRef.capacity.id,
              process_file_id: this.document.id,
              order: 0
            }
          ]
        ];
        await this.postSubscriberRequest({
          subscribers,
          hasOrder: false,
          processId: this.process.id,
          joinId: this.document.document_join_id
        });
        await this.requestProcessFiles({
          files_id: [this.document.id],
          processId: this.process.id
        });
      }
      this.isLoading = false;
    },

    showMandatorySignatureModal() {
      this.$store.commit("setCurrentProcessFileId", this.document.id);
      this.$buefy.modal.open({
        parent: this,
        component: ModalDocMandatorySignature,
        props: {
          updateFiles: this.updateProcessFiles,
          processId: this.process.id
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    openModalDeclinePublication() {
      const document = {
        ...this.document,
        document_type: this.documentType,
        nup: this.process.nup
      };
      this.$buefy.modal.open({
        parent: this,
        component: ModalDeclinePublication,
        props: {
          listDocuments: [document],
          onClose: this.updateProcessFiles
        },
        canCancel: ["escape", "x", "outside"],
        hasModalCard: true,
        trapFocus: true
      });
    },

    capacityToSign(historyList) {
      const signature = historyList.find(item => item.user_id === this.user.id);
      return signature ? signature.capacity : this.user.capacity.capacity_id;
    },

    checkIsConfidential(callback = () => null) {
      if (this.isConfidential) {
        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message: this.General.MESSAGES.ALERT_DOCUMENT_SECRECY,
            invertOutline: true,
            confirm: callback,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        callback();
      }
    },

    actionList() {
      return [
        {
          label: this.General.AUTHORIZE_DOE,
          icon: "text-box-check",
          dataCY: "AUTHORIZE_DOE",
          permission: this.canShowModalAuthorizeDOE,
          validated:
            this.document.to_publish &&
            !this.isEditable &&
            this.isUserResponsable &&
            this.hasPublish &&
            this.process.can_tramit,
          callback: () => this.showModalAuthorizeDOE()
        },
        {
          label: this.General.SIGN,
          icon: "pen",
          dataCY: "sing-document",
          validated:
            !this.isEditable &&
            (this.isUserResponsable || this.userId === this.document.user_id) &&
            !this.isNoEffect &&
            !this.isAppendedProcess &&
            this.hasPublish &&
            this.process.can_tramit &&
            !this.hasCurrentUserValidSignature,
          callback: () => this.showModalSignDocument()
        },
        {
          label: this.General.REQUEST_SUBSCRIPTION,
          icon: "pen-plus",
          dataCY: "REQUEST_SUBSCRIPTION",
          validated:
            !this.isEditable &&
            this.validateRequestSignature &&
            !this.isNoEffect &&
            !this.isAppendedProcess &&
            this.hasPublish &&
            this.process.can_tramit,
          callback: () => this.showModalDocSignature()
        },
        {
          label: this.getDownloadTooltip,
          position: "is-left",
          icon: "download",
          callback: () => this.checkIsConfidential(this.downloadFile)
        },
        {
          label: this.General.GIVE_KNOWLEDGE_DOCUMENT,
          icon: "email-send",
          validated: !this.isNoEffect && this.process.can_tramit,
          callback: () => this.showModalGiveKnowledge()
        },
        {
          label: this.General.DELETE,
          icon: "delete",
          validated:
            this.isRemoveFileAllowed &&
            !this.isAppendedProcess &&
            this.process.can_tramit,
          callback: () => this.deleteFile()
        },
        {
          label: this.General.DECLINE_DOE,
          icon: "close-thick",
          permission: this.hasPermissionAuthorizeDOE,
          validated:
            this.document.current_doe_status === "TO_PUBLISH" &&
            !this.isEditable &&
            this.process.can_tramit,
          callback: () => this.openModalDeclinePublication()
        }
      ];
    },

    capacityFormatted(capacity_id) {
      return capacity_id
        ? this.getCapacityFormatted(capacity_id)
        : General.EXTERNAL_USER;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.wrapper-document {
  border: 2px solid $custom-color-dcdcdc;
  border-left: none;
  border-right: none;
  padding: 4px 0;
  margin: 10px 0;
  display: flex;
  .link,
  & {
    width: 100%;
  }

  &:hover {
    transition: 0.5s;
    background-color: $color-2;

    .document-selected {
      color: $primary;
    }
  }
}

.custom-position-absolute {
  display: flex;
  position: absolute;
}

.custom-justify-flex-end {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  div {
    display: flex;
    gap: 5px;
  }

  @media screen and (max-width: $tablet) {
    flex-direction: column;
    &.mobile-flex-start {
      justify-content: flex-start;
    }
  }
}

.custom-badge {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  gap: 5px;
}

.custom-align-center {
  align-items: center;
}

.document-label {
  font-weight: 500;
  font-size: 14px;
}

.is-partially {
  background-color: rgb(245, 212, 105);
}

.list-sign,
.list-authenticate {
  align-self: center;
}

.list-sign div,
.list-authenticate div {
  display: flex;
  align-items: center;
}

.list-sign div.pending > div > div > .ball,
.list-sign div.signed > div > div > .ball,
.list-sign div.refused > div > div > .ball,
.list-sign div.mandatory > div > div > .ball,
.list-sign div.assigned > div > div > .ball,
.list-authenticate div.authenticated > div > div > .ball {
  border-radius: 50%;
  height: 8px;
  width: 8px;
  box-shadow: 0px 0px 8px 1px #f2f2f2;
  margin-right: 5px;
}

.list-sign div.pending > div > div > .ball {
  background-color: #ffd100;
}

.list-sign div.signed > div > div > .ball,
.list-authenticate div.authenticated > div > div > .ball {
  background-color: $primary;
}

.list-sign div.refused > div > div > .ball {
  background-color: #ff5e4a;
}

.list-sign div.mandatory > div > div > .ball {
  background-color: $blue-oil;
}

.list-sign div.assigned > div > div > .ball {
  background-color: $primary;
}
.list-sign .tooltip-content {
  background-color: red !important;
  color: blue !important;
}

.action-signature {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid $border-color;
  margin-top: 5px;
  color: $blue-oil;
}

.doc-name {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
  overflow-wrap: break-word;
  word-break: break-all;
  @media screen and (max-width: 768px) {
    max-width: 80vw;
  }
}
</style>
